/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Athlete_Not_VisibleInputs */

const en_us2_athlete_not_visible = /** @type {(inputs: Athlete_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have access to this person's training.`)
};

const pt_br2_athlete_not_visible = /** @type {(inputs: Athlete_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não tem acesso ao treino desta pessoa.`)
};

const es_419_athlete_not_visible = /** @type {(inputs: Athlete_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes acceso al entrenamiento de esta persona.`)
};

const pt_pt2_athlete_not_visible = /** @type {(inputs: Athlete_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não tens acesso ao treino desta pessoa.`)
};

const fr_fr2_athlete_not_visible = /** @type {(inputs: Athlete_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu n'as pas accès à l'entraînement de cette personne.`)
};

const de_de2_athlete_not_visible = /** @type {(inputs: Athlete_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast keinen Zugriff auf das Training dieser Person.`)
};

const it_it2_athlete_not_visible = /** @type {(inputs: Athlete_Not_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai accesso agli allenamenti di questa persona.`)
};

/**
* | output |
* | --- |
* | "You do not have access to this person's training." |
*
* @param {Athlete_Not_VisibleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const athlete_not_visible = /** @type {((inputs?: Athlete_Not_VisibleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Athlete_Not_VisibleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_athlete_not_visible(inputs)
	if (locale === "es-419") return es_419_athlete_not_visible(inputs)
	if (locale === "pt-PT") return pt_pt2_athlete_not_visible(inputs)
	if (locale === "fr-FR") return fr_fr2_athlete_not_visible(inputs)
	if (locale === "de-DE") return de_de2_athlete_not_visible(inputs)
	if (locale === "it-IT") return it_it2_athlete_not_visible(inputs)
	return en_us2_athlete_not_visible(inputs)
});
export { athlete_not_visible as "athlete.not_visible" }